<template>
  <section>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <slot name="row-1"></slot>
    </div>
    <div class="d-flex align-items-center justify-content-start pd-x-20 pd-sm-x-30">
      <div class="clear-key">
        <slot name="clearKey"></slot>
      </div>
      <div class="mg-l-auto">
        <slot name="headerLeft"></slot>
      </div>
    </div>
  </section>
</template>

<script>
export default {
}
</script>

